module.exports = __webpack_public_path__ + "img/remainder2.c8e93d35.svg";